import styled from '@emotion/styled';
import { theme, media } from '@vfit/shared/themes';

export const PillContainer = styled.div<{
  pillsColor?: string;
  opacity?: number;
  borderColor?: string;
}>`
  ${({ pillsColor }) => `background: ${pillsColor || theme.colors.bg.primary}`};
  ${({ opacity }) => `opacity: ${opacity}`};
  border-radius: 20px;
  padding: ${theme.spacing.xs} 10px;
  ${({ borderColor }) =>
    `border: ${borderColor ? `${theme.borderWidth.thin} solid ${borderColor}` : 'none'}`};

  span {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.bold};
    font-size: ${theme.typography.fontSize.caption};
    line-height: ${theme.typography.lineHeight.h4};
    text-transform: uppercase;
    color: ${theme.colors.text.primary};
    letter-spacing: 0.5px;
    white-space: nowrap;
    ${({ pillsColor }) =>
      `color: ${
        pillsColor === theme.colors.text.primary
          ? theme.colors.text.inverse
          : theme.colors.text.primary
      }`};
  }

  ${media.desktop`
    padding: 6px 12px;
  `}
`;
